import type {NextRouter} from 'next/router';
import {COMPANY_FOLLOW_RANKING} from '../../config/constants/routes';
import {FOLLOW_COMPANY_RANKING_TERMS} from '../../core/entities/company/constants';
import {createPathWithQuery} from './createPathWithQuery';

export const navigateToFollowRanking = (
  router: NextRouter,
  options: {
    term?: string;
    isLastYear?: boolean;
    preserveOtherQuery?: boolean;
  },
) => {
  const {term, isLastYear, preserveOtherQuery = true} = options;

  let query = preserveOtherQuery ? {...router.query} : {};

  if (isLastYear) {
    query = {
      ...query,
      isLastYear: 'true',
      term: term || FOLLOW_COMPANY_RANKING_TERMS.all,
    };
  } else {
    const {isLastYear: _, ...restQuery} = query;
    query = {
      ...restQuery,
      ...(term && {term}),
    };
  }

  router.push(createPathWithQuery(COMPANY_FOLLOW_RANKING, query, 'none'));
};
